import React from "react";

export default function Modal({ isOpen, setIsOpen }) {
  return (
    <div
      className={`fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white w-fit max-w-[240px] z-50 bg-[#114f94] border-2 rounded-lg py-4 duration-500 ${
        !isOpen ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <div className="flex flex-col items-center">
        <h2 className="font-bold text-xl text-center">Your message was successfully sent!</h2>
        <p className="text-xs mt-2">Please wait for the reply.</p>
        <button
          onClick={() => setIsOpen(false)}
          className="bg-white rounded-full px-8 py-2 text-xs font-bold text-black mt-4"
        >
          Close
        </button>
      </div>
    </div>
  );
}
